// extracted by mini-css-extract-plugin
module.exports = {"loading-wrap":"style_loading-wrap__Ia7xv","page-loading":"style_page-loading__3nMk8","load":"style_load__1CUqb"};